


export type FormFieldEnumerationType = 'Single' | 'Multi';

export const FormFieldEnumerationType = {
    Single: 'Single' as FormFieldEnumerationType,
    Multi: 'Multi' as FormFieldEnumerationType
};

